export enum EmploymentStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED'
}

export const employmentStatusToString = (status: EmploymentStatus) => {
  const stringsObject = {
    [EmploymentStatus.ACTIVE]: 'Active',
    [EmploymentStatus.PENDING]: 'Pending',
    [EmploymentStatus.TERMINATED]: 'Terminated'
  }

  return stringsObject[status]
}


// WEBPACK FOOTER //
// ./src/lib/interfaces/EmploymentStatus.interface.ts